module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"AdminSection":"Area Admin","ClientSection":"Area Clienti","SystemAdmin":"System Admin","UserManagement":"Gestione Utenti","support":"Assistenza"}}')
  delete Component.options._Ctor
}
